import { render } from "./DictionaryPlaceList.vue?vue&type=template&id=6aa6abb5"
import script from "./DictionaryPlaceList.vue?vue&type=script&lang=js"
export * from "./DictionaryPlaceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__